import './Details.css'
import { Collapse, Divider, Flex } from "antd"
import { FC } from "react"
import { services } from "../../contents/services"
import { ResponsiveContext, useResponxiveContext } from "../../context/responsive-context"
import { ServiceCategory } from "../../types"
import { ServiceCard } from "./ServiceCard"
import { details } from '../../contents/details'
import { CollapseProps } from 'antd/lib'
import { RightOutlined, DownOutlined } from '@ant-design/icons'

const expandIcon = (collapsed?: boolean) => {
  if (!collapsed) {
  return (
    <RightOutlined style={{ fontSize: '24px' }} />
  )
  }
  return (
    <DownOutlined style={{ fontSize: '24px' }} />
  )
}
export const Details: FC<{ category: ServiceCategory }> = ({ category }) => {
  const { useVertical } = useResponxiveContext()
  let i = 0
  const bulletpoints: CollapseProps['items'] = details[category].bulletpoints.map(bp => {
    return (
    {
      key: ++i,
      label:
        <>
        <div className={useVertical ? "Details-bulletpoints-header-vertical" :"Details-bulletpoints-header"}>{bp.title}</div>
        <hr className="Details-divider"/>
          </>,
      children:
      <>
        <div className={useVertical ? "Details-bulletpoints-body-vertical" :"Details-bulletpoints-body"}>{bp.body}</div>
      </>
    })
  })
  return (
    <Flex className="Details-container" vertical>
      <Flex className={useVertical ? "Details-header-vertical" : "Details-header"} vertical>
      {details[category].header}
      </Flex>
      <Flex className={useVertical ? "Details-bulletpoints-container-vertical" : "Details-bulletpoints-container"} justify={'space-evenly'} vertical>
      <Collapse accordion items={bulletpoints} bordered={false} expandIconPosition={'end'} expandIcon={({isActive}) => expandIcon(isActive)} ghost size='large' />
      </Flex>
    </Flex>
  )
}

